export default __webpack_public_path__ + "static/media/approch1.157833aa.jpg";